import { createSlice, PayloadAction, Slice } from "@reduxjs/toolkit";
import { RootState } from "utils/store";

export interface generalState {
  isFirstNameMandatory: boolean;
  campaignRetentionDuration: number;
  isManager: boolean;
  isCampaignSubmitted: boolean;
}

const initialState: generalState = {
  isFirstNameMandatory: true,
  campaignRetentionDuration: 1,
  isManager: false,
  isCampaignSubmitted: true,
};

export const generalStateSlice: Slice = createSlice({
  name: "general",
  initialState,
  reducers: {
    changeIsFirstNameMandatory: (state, action: PayloadAction<boolean>) => {
      state.isFirstNameMandatory = action.payload;
    },
    campaignRetentionDuration: (state, action: PayloadAction<number>) => {
      state.campaignRetentionDuration = action.payload;
    },
    addIsManager: (state, action: PayloadAction<boolean>) => {
      state.isManager = action.payload;
    },
    changeIsCampaignSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isCampaignSubmitted = action.payload;
    },
  },
});

export const {
  changeIsFirstNameMandatory,
  campaignRetentionDuration,
  addIsManager,
  changeIsCampaignSubmitted,
} = generalStateSlice.actions;

export const selectIsFirstNameMandatory = (state: RootState) =>
  state.general.isFirstNameMandatory;
export const selectCampaignRetentionDuration = (state: RootState) =>
  state.general.campaignRetentionDuration;
export const selectIsManager = (state: RootState) => state.general.isManager;
export const selectIsCampaignSubmitted = (state: RootState) =>
  state.general.isCampaignSubmitted;

export default generalStateSlice.reducer;
